import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GuestAuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    protected readonly authService: AuthService
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const baseUrl = _.data['baseUrl'] + '/auth';

    const allowAnonymous = _.queryParamMap.get('allowAnonymous') === 'true';

    if (allowAnonymous) {
      // Force the guard to wait for the token before proceeding
      // Using firstValueFrom converts the Observable to a Promise
      try {
        await firstValueFrom(this.authService.fetchGuestToken(baseUrl));
        this.authService.setAllowAnonymous(true);
        return true;
      } catch (err) {
        this.authService.setAllowAnonymous(false);
        return false;
      }
    }

    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
        locale: localStorage.getItem('locale') ?? 'en-US',
      });
    }
    return this.authenticated;
  }
}
